import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { DatePipe, NgClass, NgIf } from "@angular/common";

@Component({
  selector: 'session-stopwatch',
  standalone: true,
  templateUrl: './stopwatch.component.html',
  imports: [
    NgIf,
    NgClass,
    DatePipe
  ],
  styleUrls: ['./stopwatch.component.scss']
})
export class StopwatchComponent implements OnDestroy {

    @Input() title: string = ''
    @Input() duration: number = 0;
    @Output() close: EventEmitter<any> = new EventEmitter();
    counter: number | undefined;
    timerRef: any;
    running: boolean = false;
    expired: boolean = false;
    audio: HTMLAudioElement;

    constructor() {
        this.audio = new Audio('../../../../../assets/sounds/ring.wav');
    }

    startTimer() {
        this.running = !this.running;
        if (this.running) {
            const startTime = Date.now() - (this.counter || 0);
            this.timerRef = setInterval(() => {
                this.counter = Date.now() - startTime;
                if (this.counter >= this.duration && !this.expired) {
                    this.expired = true;
                    this.audio.play();
                }
            }, 1000);
        } else {
            clearInterval(this.timerRef);
        }
    }

    clearTimer() {
        this.running = false;
        this.counter = undefined;
        this.expired = false;
        clearInterval(this.timerRef);
    }


    ngOnDestroy() {
        clearInterval(this.timerRef);
    }
}
